import React from "react"
import Container from "../../atoms/Container"
import "./InHetKort.css"
import PrimaryButton from "../../atoms/Buttons/PrimaryButton"

export default function InHetKort({ block }) {
  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-inhetkort-container">
        <div className="vt-inhetkort-inner">
          <h2>{block.inHetKort.titel}</h2>
        </div>
        <div className="vt-inhetkort-inner-content">
          <div
            dangerouslySetInnerHTML={{ __html: block.inHetKort.tekst }}
          ></div>
          <PrimaryButton
            label={block.inHetKort.label}
            color={"red"}
            target={block.inHetKort.link}
          />
        </div>
      </div>
    </Container>
  )
}
